/**
 * No-op Sentry stub used in non-production builds.
 * This module is aliased over @sentry/react by webpack when APP_ENV !== "production",
 * so that zero Sentry code is ever bundled or shipped outside of production.
 */

export const init = () => {};
export const browserTracingIntegration = () => ({});

/** Passthrough component — mirrors <Sentry.ErrorBoundary> API surface used in the app. */
export const ErrorBoundary = ({ children }) => children;

export default { init, browserTracingIntegration, ErrorBoundary };
